import { useCallback } from "react";
import { useToastNotification } from "../../components/ToastNotifications";

/**
 * Convenience hook for showing success/error toast notifications.
 * @returns {{ showSuccessToast: (message: string) => void, showErrorToast: (message: string) => void }}
 */
export const useToasts = () => {
  const { openToast } = useToastNotification();

  const showSuccessToast = useCallback(
    (message) => {
      openToast(message, "success");
    },
    [openToast],
  );

  const showErrorToast = useCallback(
    (message) => {
      openToast(message, "error");
    },
    [openToast],
  );

  return { showSuccessToast, showErrorToast };
};
